<template>
  <div class="dropdown-multiple-select-button">
    <p v-if="title" class="dropdown-multiple-select-menu-button_title">
      {{ $t(title) }}<span v-if="required" class="red">*</span>
    </p>
    <ValidationProvider
      v-slot="{ errors }"
      v-click-outside="$_dropdownClose"
      :rules="rules"
      class="dropdown-multiple-select-menu-button_content-wrap"
    >
      <input type="hidden" :value="value" />
      <div
        class="dropdown-multiple-select-menu-button_content"
        :class="{
          outline: outline,
          narrow: narrow,
          wide: wide,
          disabled: disabled,
          error: errors.length > 0,
        }"
      >
        <i v-if="leadingIcon" class="icon leading-icon" :class="leadingIcon" />
        <button class="input-button" @click="$_onclick()">
          <p class="select" :class="{ active: _isActive }">
            {{ $t(_computedButtonTextLabel) }}
          </p>
          <p v-if="_remainNumber > 0" class="num">
            {{ _remainNumber }}
          </p>
        </button>
        <i
          v-if="outline || disabled"
          class="icon trailing-icon outline icon-chevron-up"
          :class="{ show: dropdown_menu_show }"
        />
        <i
          v-else-if="!outline && !dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-down-circle"
        />
        <i
          v-else-if="!outline && dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-up-circle"
        />
        <transition mode="out-in">
          <div v-if="dropdown_menu_show" class="dropdown-menu">
            <div v-if="selectAll" class="search-tool btn">
              <button class="select-all-btn" @click="$_selectAll()">
                <i :class="_allBtnIcon" class="select-all-btn-icon" /> <span>{{ $t('全部') }}</span>
              </button>
            </div>
            <perfect-scrollbar class="ps dropdown-scrollable-content">
              <div
                v-for="(firstLayer, firstLayerKey) in menuItems"
                :key="firstLayerKey"
                class="classification-list"
              >
                <!-- First Layer -->
                <div class="classification-subtitle">
                  <div v-for="(secondLayer, secondLayerKey) in firstLayer" :key="secondLayerKey">
                    <label>
                      <input
                        type="checkbox"
                        :checked="$_checked(secondLayer, firstLayerKey)"
                        @change="$_onChange($event, secondLayer.value, firstLayerKey)"
                      />
                      <div class="checkbox-icon">
                        <i class="checked icon-check-box" />
                        <i class="unchecked icon-check-box-outline-blank" />
                      </div>
                      <span>{{ $t(secondLayer.text) }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </perfect-scrollbar>
          </div>
        </transition>
      </div>
      <div v-if="errors.length > 0" class="invalid-text">
        <i class="icon-warning invalid-icon" />
        <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
          {{ $t(text_e) }}
        </p>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', {
  ...required,
  message: '此項目為必填',
});
export default {
  name: 'DropdownCustomedMultipleSelectButton',
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    menuItems: {
      type: Array,
      default() {
        return [];
      },
    },
    leadingIcon: {
      type: String,
      default: '',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    selectAll: {
      type: Boolean,
      default: false,
    },
    allSelectText: {
      type: String,
    },
  },
  data() {
    return {
      dropdown_menu_show: false,
      searchInputButton: {
        value: '',
        placeholder: this.$t('搜尋'),
        textLabel: this.$t('搜尋'),
      },
    };
  },
  computed: {
    _allBtnIcon() {
      const allValue = [];
      this.menuItems.forEach(menu => {
        allValue.push(menu);
      });
      if (this._remainNumber < this._allNumber && this._remainNumber > 0) {
        return 'icon-indeterminate-check-box';
      } else if (this._remainNumber === 0) {
        return 'icon-check-box-outline-blank';
      }
      return 'icon-check-box';
    },
    _computedButtonTextLabel() {
      if (this._remainNumber === this._allNumber) {
        return this.allSelectText ? this.allSelectText : '全部';
      } else if (this._remainNumber == 0) {
        return this.placeholder;
      } else {
        let _selectValue = [];
        const selectValue = JSON.parse(JSON.stringify(this.value));
        this.menuItems.forEach((items, itemsIndex) => {
          items.forEach(item => {
            if (selectValue[itemsIndex].includes(item.value)) {
              _selectValue.push(item.text);
            }
          });
        });
        return _selectValue.join('、');
      }
    },
    _remainNumber() {
      let selectNumber = 0;
      for (let i = 0; i < this.value.length; i++) {
        selectNumber = selectNumber + this.value[i].length;
      }
      return selectNumber;
    },
    _allNumber() {
      let selectNumber = 0;
      for (let i = 0; i < this.menuItems.length; i++) {
        selectNumber = selectNumber + this.menuItems[i].length;
      }
      return selectNumber;
    },
    _isActive() {
      let isActive = false;
      this.value.forEach(_value => {
        if (_value.length > 0) isActive = true;
      });
      return isActive;
    },
  },
  methods: {
    $_checked(data, layer) {
      if (!this.value[layer]) return false;
      if (this.value[layer].includes(data.value)) {
        return true;
      }
      return false;
    },
    $_selectAll() {
      let allArr = [[], []];
      const newValue = JSON.parse(JSON.stringify(this.menuItems));
      let allValue = [];
      newValue.forEach(layer => {
        let _layer = [];
        layer.forEach(item => {
          _layer.push(item.value);
        });
        allValue.push(_layer);
      });
      if (this._remainNumber < this._allNumber) {
        allArr = allValue;
      }
      this.$emit('input', allArr);
      this.$emit('click');
    },
    $_onclick() {
      if (this.disabled) return;
      this.$_toggleDropdownMenuShow();
    },
    $_toggleDropdownMenuShow() {
      this.dropdown_menu_show = !this.dropdown_menu_show;
    },
    $_dropdownClose() {
      this.dropdown_menu_show = false;
      this.addMemberActive = false;
    },
    $_onChange($event, value, layer) {
      let newValue = JSON.parse(JSON.stringify(this.value));
      if ($event.target.checked) {
        if (!newValue[layer].includes(value)) {
          newValue[layer].push(value);
        }
      } else {
        newValue[layer] = newValue[layer].filter(item => item !== value);
      }
      this.$emit('input', newValue);
      this.$emit('click');
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/dropdown-multiple-select-button';
</style>
